<app-header></app-header>
<!-- <section class="container">
    <router-outlet></router-outlet>
</section> -->

<!-- <div style="background-image: url('assets/img/WhatsApp Image 2022-10-06 at 6.24.36 PM.jpeg'); height: 100%; background-repeat: no-repeat; background-size: cover;">

</div> -->